import Merchandise from "../images/merchandise.png";
import adventureworks from "../images/adventureworks.png";
import KPI from "../images/KPI Dashboard image.png";
import regional from "../images/Regional Dashboard picture.png";
import halloween from "../images/halloween.png";
import christmas from "../images/christmas.png";
import employee from "../images/employee.png";
import candy from "../images/candy.png";
import spotify from "../images/Spotify.png";
import email from "../images/email.png";
import india from "../images/india.png";
import supply from "../images/supply.png";
import hub from "../images/hub.png";
import HealthCare from "../images/data-cleaning.png";
import Airline from "../images/Airline.png";
import population from "../images/Population 1.png";
import shipment from "../images/shipment.png";
import baby_name_trend from "../images/baby_name_trend.png";
import restaurant_order from "../images/restaurant_order.png";
import financial_report from "../images/Financial report.png";
import panic_attack from "../images/Screenshot_5.png";
import customer_sat from "../images/CustomerSat.png";
import ithelpdesk from "../images/IT Helpdesk.png";
import cricket from "../images/cricket.png";
import fitness from "../images/fitness.png";
import athletics from "../images/athletics.png";
import pythonsummer from "../images/pythonsummer.png";
import hr_report from "../images/HR.png";
import cust_compl from "../images/complaint.png";
import socialMedia from "../images/socialmedia.png";
import animal1 from "../images/animal1.png";
import sqladvent from "../images/sql_advent_1.png";
import Pharma from "../images/pharma sales.png";
import real_estate from "../images/EUrealestate.png";
import fintech from "../images/fintech.png";
import Ecommerce from "../images/E-commerce.png";
import supplychain from "../images/supplychain.png";
import clinical from "../images/clinicalreport.png";
import procurement from "../images/procurement.png";
import oilgas from "../images/oil&gas.png";
import glowmart from "../images/glowmart.png";
import legal from "../images/legal_report.png";



const ProjectData = [
  {
    id: "Legal123",
    title: "LexEuropa Legal Analytics Report",
    url: "https://app.powerbi.com/view?r=eyJrIjoiZmZjZjkwNTMtMzYxMi00NzY2LTk1NzUtYzBlN2UxNDU1OGI0IiwidCI6IjQ2NTRiNmYxLTBlNDctNDU3OS1hOGExLTAyZmU5ZDk0M2M3YiIsImMiOjl9&disablecdnExpiration=1786390378",
    pic: legal,
    description:
      "A comprehensive LexEuropa Legal Analytics Report. This report is designed to provide valuable insights into legal operations, helping law firms and legal professionals optimize their processes and make informed decisions. Through the use of advanced analytics and data visualization techniques, this report offers a deep dive into key performance indicators, case management metrics, and operational efficiency. Whether you're a legal professional or simply interested in understanding the complexities of legal operations, this report is a must-read. Check it out and let me know your thoughts!",
    code: "https://github.com/idowuemmao/LexEuropa_Legal_Performance_Report",
    stack: [
      "Power Query",
      "Power BI",
      "ZoomCharts",
      "DAX and Measures"
    ],
  },
  {
    id: "OILGAS22",
    title: "Oil, Gas & Energy Operations Analytics Report",
    url: "https://app.powerbi.com/view?r=eyJrIjoiZDA5ZGRhZGItMDY2ZS00N2MwLTgwYmEtNzE3OTM1ZjNmODQ5IiwidCI6IjQ2NTRiNmYxLTBlNDctNDU3OS1hOGExLTAyZmU5ZDk0M2M3YiIsImMiOjl9",
    pic: oilgas,
    description:
      "A comprehensive Oil, Gas & Energy Operations Analytics Report. This report is designed to provide valuable insights into the operations of the oil and gas industry, helping stakeholders optimize their processes and make informed decisions. Through the use of advanced analytics and data visualization techniques, this report offers a deep dive into key performance indicators, production metrics, and operational efficiency. Whether you're an industry professional or simply interested in understanding the complexities of oil and gas operations, this report is a must-read. Check it out and let me know your thoughts!",
    code: "https://github.com/idowuemmao/oil-gas-operations-analytics-powerbi",
    stack: [
      "Power Query",
      "Power BI",
      "ZoomCharts",
      "DAX and Measures",
      "Canva",
    ],
  },
  {
    id: "GLOWM12",
    title: "GlowMart E-Commerce Analytics Report",
    url: "https://www.linkedin.com/feed/update/urn:li:activity:7477439034701561856/",
    pic: glowmart,
    description:
      "A comprehensive GlowMart E-Commerce Analytics Report. This report is designed to provide valuable insights into the operations of the e-commerce industry, helping stakeholders optimize their processes and make informed decisions. Through the use of advanced analytics and data visualization techniques, this report offers a deep dive into key performance indicators, sales metrics, and customer behavior. Whether you're an industry professional or simply interested in understanding the complexities of e-commerce operations, this report is a must-read. Check it out and let me know your thoughts!",
    code: "https://github.com/idowuemmao/glowmart-nigeria-sales-inventory-bi",
    stack: [
      "Power Query",
      "Power BI",
      "ZoomCharts",
      "DAX and Measures",
      "Canva",
    ],
  },
  {
    id: "WOEIE2",
    title: "Supply Chain Analytics Report",
    url: "https://app.powerbi.com/view?r=eyJrIjoiYzM3NmU3NjYtZTI1ZS00ODcyLWJiOTItNTZmM2ZlOTlmYzlmIiwidCI6IjQ2NTRiNmYxLTBlNDctNDU3OS1hOGExLTAyZmU5ZDk0M2M3YiIsImMiOjl9",
    pic: supplychain,
    description:
      "A comprehensive Supply Chain Analytics Report. This report is designed to provide valuable insights into the intricacies of supply chain management, helping businesses optimize their operations and make informed decisions. Through the use of advanced analytics and data visualization techniques, this report offers a deep dive into key performance indicators, inventory management, demand forecasting, and logistics efficiency. Whether you're a supply chain professional or simply interested in understanding the complexities of modern supply chains, this report is a must-read. Check it out and let me know your thoughts!",
    code: "https://github.com/idowuemmao/Food-Beverage-Supply-Chain-Analytics-Dashboard-Power-BI",
    stack: [
      "Power Query",
      "Power BI",
      "ZoomCharts",
      "DAX and Measures",
      "Canva",
    ],
  },
  {
    id: "EWIOM2",
    title: "Procurement Analytics Report ",
    url: "https://app.powerbi.com/view?r=eyJrIjoiZDM1ZDAyZTUtZWQ4Yi00NzU2LThjZTItNGU1ZjMzNDhkNmYwIiwidCI6IjQ2NTRiNmYxLTBlNDctNDU3OS1hOGExLTAyZmU5ZDk0M2M3YiIsImMiOjl9",
    pic: procurement,
    description:
      "A comprehensive Procurement Analytics Report. This report is designed to provide valuable insights into procurement processes, helping businesses optimize their purchasing strategies and make informed decisions. Through the use of advanced analytics and data visualization techniques, this report offers a deep dive into key performance indicators, supplier performance, cost analysis, and procurement efficiency. Whether you're a procurement professional or simply interested in understanding the complexities of modern procurement, this report is a must-read. Check it out and let me know your thoughts!",
    code: "https://github.com/idowuemmao/procurement_analytics_report",
    stack: [
      "Power Query",
      "Power BI",
      "ZoomCharts",
      "DAX and Measures",
      "Canva",
    ],
  },
  {
    id: "HGET0s32",
    title: "Hypertension BP Control Analytics",
    url: "https://www.linkedin.com/feed/update/urn:li:activity:7458223833632784384/",
    pic: clinical,
    description:
      "A comprehensive Hypertension BP Control Analytics report. This report is designed to provide valuable insights into the management of hypertension and blood pressure control, helping healthcare professionals optimize their treatment strategies and make informed decisions. Through the use of advanced analytics and data visualization techniques, this report offers a deep dive into key performance indicators, patient outcomes, and treatment effectiveness. Whether you're a healthcare professional or simply interested in understanding the complexities of hypertension management, this report is a must-read. Check it out and let me know your thoughts!",
    code: "https://github.com/idowuemmao/hypertension-bp-control-analytics",
    stack: [
      "Power Query",
      "Power BI",
      "ZoomCharts",
      "DAX and Measures",
      "Canva",
    ],
  },
  {
    id: "POOps32",
    title: "EU Real Estate Market Analytics",
    url: "https://app.powerbi.com/view?r=eyJrIjoiZGUxZjBmZDYtNmZmYy00ZGI1LWIwZDEtMzJjOTlhOGFiMzUyIiwidCI6IjQ2NTRiNmYxLTBlNDctNDU3OS1hOGExLTAyZmU5ZDk0M2M3YiIsImMiOjl9",
    pic: real_estate,
    description:
      "A comprehensive EU Real Estate Market Analytics report. This report is designed to provide valuable insights into the dynamics of the European real estate market, helping investors, developers, and industry professionals make informed decisions. Through the use of advanced analytics and data visualization techniques, this report offers a deep dive into key performance indicators, market trends, property values, and investment opportunities across various European countries. Whether you're a real estate professional or simply interested in understanding the complexities of the European real estate market, this report is a must-read. Check it out and let me know your thoughts!",
    code: "https://github.com/idowuemmao/European-Real-Estate-Market-Analytics",
    stack: [
      "Power Query",
      "Power BI",
      "ZoomCharts",
      "DAX and Measures",
      "Canva",
    ],
  },
  {
    id: "PP98S32",
    title: "Pharmacy Sales & Promotion Report",
    url: "https://app.powerbi.com/view?r=eyJrIjoiODcwYjI5ODgtZDFlNi00MmFjLWI2ZjAtNDFmYTVjZWNiOTM0IiwidCI6IjQ2NTRiNmYxLTBlNDctNDU3OS1hOGExLTAyZmU5ZDk0M2M3YiIsImMiOjl9&disablecdnExpiration=1771951054",
    pic: Pharma,
    description:
      "A comprehensive Pharmacy Sales & Promotion Analytics report. This report is designed to provide valuable insights into the dynamics of pharmacy sales and promotion strategies, helping pharmaceutical companies optimize their marketing efforts and make informed decisions. Through the use of advanced analytics and data visualization techniques, this report offers a deep dive into key performance indicators, sales trends, promotion effectiveness, and customer behavior in the pharmaceutical industry. Whether you're a pharmaceutical professional or simply interested in understanding the complexities of pharmacy sales and promotion, this report is a must-read. Check it out and let me know your thoughts!",
    code: "https://github.com/idowuemmao/pharmacy-sales-promotion-analytics-powerbi",
    stack: [
      "Power Query",
      "Power BI",
      "ZoomCharts",
      "DAX and Measures",
      "Canva",
    ],
  },
  {
    id: "IUE212",
    title: "SQL Advent Calender",
    url: "https://github.com/idowuemmao/SQL_Advent_Calender",
    pic: sqladvent,
    description:
      "This project is designed to provide a fun and engaging way to learn SQL throughout the month of December. Each day, a new SQL challenge or problem is released, allowing participants to practice their SQL skills and improve their understanding of database management and querying. Whether you're a beginner looking to learn SQL or an experienced developer looking for a fun way to stay sharp, the SQL Advent Calendar is a great resource. Check it out and join in on the fun!",
    code: "https://github.com/idowuemmao/SQL_Advent_Calender",
    stack: ["SQL", "PostgreSQL", "SQLite", "Interview Master AI"],
  },
  {
    id: "WWQqr432",
    title: "E-commerce Analytics Dashboard",
    url: "https://app.powerbi.com/view?r=eyJrIjoiODcwYjgzOTctODcwZS00NmFhLWE0YjQtZjBkMTUwNzQ1NWNjIiwidCI6IjQ2NTRiNmYxLTBlNDctNDU3OS1hOGExLTAyZmU5ZDk0M2M3YiIsImMiOjl9",
    pic: Ecommerce,
    description:
      "An E-commerce Analytics Dashboard. This dashboard is designed to provide real-time insights into e-commerce performance, helping businesses make data-driven decisions. Through the use of advanced analytics and data visualization techniques, this dashboard offers a comprehensive view of key performance indicators, sales trends, and customer behavior. Whether you're a business owner or a data analyst, this dashboard is a valuable tool for understanding and optimizing your e-commerce operations. Check it out and let me know your thoughts!",
    code: "https://github.com/idowuemmao/E-commerce-Analytics-Report",
    stack: [
      "Power Query",
      "Power BI",
      "ZoomCharts",
      "DAX and Measures",
      "Canva",
    ],
  },
  {
    id: "ruwY40232",
    title: "Animal Shelter Operation Report",
    url: "https://app.powerbi.com/view?r=eyJrIjoiNDg0ZTIzNDEtYjc2Zi00ZTA4LTk1ZDUtNjA2ZTEzNzAyZTY0IiwidCI6IjQ2NTRiNmYxLTBlNDctNDU3OS1hOGExLTAyZmU5ZDk0M2M3YiIsImMiOjl9",
    pic: animal1,
    description:
      "An Animal Shelter Operation Report. This report is designed to provide valuable insights into the operations of animal shelters, helping administrators and volunteers make informed decisions. Through the use of advanced analytics and data visualization techniques, this report offers a deep dive into key performance indicators, adoption rates, animal care metrics, and resource utilization. Whether you're a shelter professional or a volunteer, this report is a must-read. Check it out and let me know your thoughts!",
    code: "https://github.com/idowuemmao/Animal-Shelter-Operation-Report",
    stack: [
      "Power Query",
      "Power BI",
      "ZoomCharts",
      "DAX and Measures",
      "Canva",
    ],
  },
  {
    id: "B54BY432",
    title: "Fintech Project Management Performance Analytics",
    url: "https://app.powerbi.com/view?r=eyJrIjoiNTQ5Y2YwNTItMjJjZi00NzY0LThjNzEtOTc4NDgzYmY2NjNkIiwidCI6IjQ2NTRiNmYxLTBlNDctNDU3OS1hOGExLTAyZmU5ZDk0M2M3YiIsImMiOjl9",
    pic: fintech,
    description:
      "A comprehensive Fintech Project Management Performance Analytics report. This report is designed to provide valuable insights into the performance of fintech projects, helping project managers and stakeholders make informed decisions. Through the use of advanced analytics and data visualization techniques, this report offers a deep dive into key performance indicators, project timelines, resource allocation, and overall project success metrics. Whether you're a fintech professional or simply interested in understanding the complexities of fintech project management, this report is a must-read. Check it out and let me know your thoughts!",
    code: "https://github.com/idowuemmao/Fintech-Project-Management-Report",
    stack: [
      "Power Query",
      "Power BI",
      "ZoomCharts",
      "DAX and Measures",
      "Canva",
    ],
  },
  {
    id: "BBY432",
    title: "Consumer Complaint Report",
    url: "https://app.powerbi.com/view?r=eyJrIjoiMzM5NGEzYjEtYzdlZC00ZGVkLWEyMjctMjc0ODNmMmU1M2U5IiwidCI6IjQ2NTRiNmYxLTBlNDctNDU3OS1hOGExLTAyZmU5ZDk0M2M3YiIsImMiOjl9",
    pic: cust_compl,
    description:
      "A comprehensive Consumer Complaint Report. This report is designed to provide valuable insights into consumer complaints, helping businesses and regulatory bodies understand and address customer concerns effectively. Through the use of advanced analytics and data visualization techniques, this report offers a deep dive into key performance indicators, complaint trends, resolution rates, and customer satisfaction metrics. Whether you're a business owner or a consumer advocate, this report is a must-read. Check it out and let me know your thoughts!",
    code: "https://github.com/idowuemmao/Customer-Complaint-Report",
    stack: [
      "Power Query",
      "Power BI",
      "ZoomCharts",
      "DAX and Measures",
      "Canva",
    ],
  },
  {
    id: "MY432",
    title: "HR Analytics Report",
    url: "https://app.powerbi.com/view?r=eyJrIjoiOWU0OTY5MDUtZWUwZi00OGMyLWE5ODItNzcyZmFmYmY4Njg0IiwidCI6IjQ2NTRiNmYxLTBlNDctNDU3OS1hOGExLTAyZmU5ZDk0M2M3YiIsImMiOjl9",
    pic: hr_report,
    description:
      "A comprehensive HR Analytics Report. This report is designed to provide valuable insights into human resources management, helping HR professionals and business leaders make informed decisions. Through the use of advanced analytics and data visualization techniques, this report offers a deep dive into key performance indicators, employee engagement metrics, turnover rates, and workforce demographics. Whether you're an HR professional or simply interested in understanding the complexities of human resources management, this report is a must-read. Check it out and let me know your thoughts!",
    code: "https://github.com/idowuemmao/HR_Analysis_Report",
    stack: [
      "Power Query",
      "Power BI",
      "ZoomCharts",
      "DAX and Measures",
      "Canva",
    ],
  },
  {
    id: "MY212",
    title: "Python Summer Party",
    url: "https://github.com/idowuemmao/python-summer-party-solutions",
    pic: pythonsummer,
    description:
      "A comprehensive Python Summer Party Solutions repository. This project is designed to provide valuable insights and solutions for various Python programming challenges, helping developers of all levels enhance their coding skills and problem-solving abilities. Through the use of advanced algorithms and data structures, this repository offers a wide range of solutions to common programming problems, making it a valuable resource for anyone looking to improve their Python programming skills. Whether you're a beginner or an experienced developer, this repository is a must-visit. Check it out and let me know your thoughts!",
    code: "https://github.com/idowuemmao/python-summer-party-solutions",
    stack: ["Python", "Pandas", "NumPy", "Interview Master AI"],
  },
  {
    id: "PU2121",
    title: "Fitness Membership Report",
    url: "https://app.powerbi.com/view?r=eyJrIjoiZTNmMmVkNDMtZjA2YS00ZWFhLWFjMzQtNzMxZDJlYzZjN2NlIiwidCI6IjQ2NTRiNmYxLTBlNDctNDU3OS1hOGExLTAyZmU5ZDk0M2M3YiIsImMiOjl9&disablecdnExpiration=1756500500",
    pic: fitness,
    description:
      "A comprehensive Fitness Membership Report. This report is designed to provide valuable insights into fitness membership trends, helping businesses and members make informed decisions. Through the use of advanced analytics and data visualization techniques, this report offers a deep dive into key performance indicators, membership retention rates, and customer satisfaction metrics. Whether you're a fitness professional or a member looking to optimize your workout experience, this report is a must-read. Check it out and let me know your thoughts!",
    code: "https://github.com/idowuemmao/fitness_membership_analysis",
    stack: [
      "Power Query",
      "Power BI",
      "ZoomCharts",
      "DAX and Measures",
      "Canva",
    ],
  },
  {
    id: "99238W",
    title: "Sport Injury Report",
    url: "https://app.powerbi.com/view?r=eyJrIjoiYWJjZDYxY2EtM2I3Yy00ZDIwLTgzMGQtNWU3ZWEwZDVjYWZmIiwidCI6IjQ2NTRiNmYxLTBlNDctNDU3OS1hOGExLTAyZmU5ZDk0M2M3YiIsImMiOjl9",
    pic: athletics,
    description:
      "A comprehensive Sport Injury Report. This report is designed to provide valuable insights into sports injuries, helping athletes, coaches, and healthcare professionals make informed decisions. Through the use of advanced analytics and data visualization techniques, this report offers a deep dive into key performance indicators, injury trends, recovery times, and prevention strategies. Whether you're an athlete looking to optimize your training or a healthcare professional focused on sports medicine, this report is a must-read. Check it out and let me know your thoughts!",
    code: "https://github.com/idowuemmao/Athletics-and-Injury-Report",
    stack: ["Power Query", "Power BI", "ZoomCharts", "DAX and Measures"],
  },
  {
    id: "P212",
    title: "Customer Satisfaction Report",
    url: "https://app.powerbi.com/view?r=eyJrIjoiYzU2OGIyMDgtMzdkYS00NWNhLWI2NjUtZDM3MDQ0ZWM1NGVhIiwidCI6IjQ2NTRiNmYxLTBlNDctNDU3OS1hOGExLTAyZmU5ZDk0M2M3YiIsImMiOjl9",
    pic: customer_sat,
    description:
      "A comprehensive Customer Satisfaction Report. This report is designed to provide valuable insights into customer satisfaction levels, helping businesses understand their customers' needs and improve their services. Through the use of advanced analytics and data visualization techniques, this report offers a deep dive into key performance indicators, customer feedback, and satisfaction metrics. Whether you're a business owner looking to enhance your customer experience or a marketer focused on improving customer retention, this report is a must-read. Check it out and let me know your thoughts!",
    code: "https://github.com/idowuemmao/Customer_satisfaction_report",
    stack: ["Power Query", "Power BI", "ZoomCharts", "DAX and Measures"],
  },
  {
    id: "P0302121",
    title: "IT HelpDesk Report ",
    url: "https://app.powerbi.com/view?r=eyJrIjoiOWUwYjVlNmYtZDYyZC00MWNmLWI0YmEtNWViNzBlMDUxZTI5IiwidCI6IjQ2NTRiNmYxLTBlNDctNDU3OS1hOGExLTAyZmU5ZDk0M2M3YiIsImMiOjl9",
    pic: ithelpdesk,
    description:
      "A comprehensive IT HelpDesk Report. This report is designed to provide valuable insights into IT helpdesk operations, helping businesses optimize their support services and improve customer satisfaction. Through the use of advanced analytics and data visualization techniques, this report offers a deep dive into key performance indicators, ticket resolution times, and customer feedback. Whether you're an IT professional looking to enhance your helpdesk operations or a business owner focused on improving customer support, this report is a must-read. Check it out and let me know your thoughts!",
    code: "https://github.com/idowuemmao/IT_HelpDesk_Report",
    stack: [
      "Power Query",
      "Power BI",
      "ZoomCharts",
      "DAX and Measures",
      "Canva",
    ],
  },
  {
    id: "PE2121",
    title: "Social Media Report",
    url: "https://app.powerbi.com/view?r=eyJrIjoiNGQ3ZDI3ZTUtZTE0YS00Y2VmLThjM2EtOWJmMDYwZTliYzgwIiwidCI6IjQ2NTRiNmYxLTBlNDctNDU3OS1hOGExLTAyZmU5ZDk0M2M3YiIsImMiOjl9",
    pic: socialMedia,
    description:
      "A comprehensive Social Media Report. This report is designed to provide valuable insights into social media performance, helping businesses understand their online presence and engage with their audience more effectively. Through the use of advanced analytics and data visualization techniques, this report offers a deep dive into key performance indicators, engagement metrics, and content performance. Whether you're a marketing professional looking to optimize your social media strategy or a business owner focused on building a strong online brand, this report is a must-read. Check it out and let me know your thoughts!",
    code: "https://github.com/idowuemmao/Social_Media_Report",
    stack: [
      "Power Query",
      "Power BI",
      "ZoomCharts",
      "DAX and Measures",
      "Canva",
    ],
  },
  {
    id: "P2121",
    title: "Panic Attack Report",
    url: "https://www.linkedin.com/posts/emmanuel-idowu-analyst_powerbi-snowflake-healthcareanalytics-activity-7338573276513734657-Q33O",
    pic: panic_attack,
    description:
      "A comprehensive Panic Attack Report. This report is designed to provide valuable insights into panic attacks, helping healthcare professionals and individuals understand the triggers, symptoms, and management strategies for panic attacks. Through the use of advanced analytics and data visualization techniques, this report offers a deep dive into key performance indicators, patient outcomes, and treatment effectiveness. Whether you're a healthcare professional focused on mental health or an individual looking to better understand panic attacks, this report is a must-read. Check it out and let me know your thoughts!",
    code: "https://github.com/idowuemmao/Panic_Attack_Report",
    stack: ["Snowflake", "Power Query", "Power BI", "DAX and Measures"],
  },
  {
    id: "P002121",
    title: "Financial Statement Report",
    url: "https://app.powerbi.com/view?r=eyJrIjoiYzg0YTM2ODAtMTQ0Yi00OGUwLWE3M2YtYTU4NmViNTdhZjE3IiwidCI6IjQ2NTRiNmYxLTBlNDctNDU3OS1hOGExLTAyZmU5ZDk0M2M3YiIsImMiOjl9",
    pic: financial_report,
    description:
      "A comprehensive Financial Statement Report. This report is designed to provide valuable insights into financial performance, helping businesses understand their financial health and make informed decisions. Through the use of advanced analytics and data visualization techniques, this report offers a deep dive into key financial metrics, revenue streams, and expense patterns. Whether you're a finance professional looking to optimize your financial reporting or a business owner focused on improving financial transparency, this report is a must-read. Check it out and let me know your thoughts!",
    code: "https://github.com/idowuemmao/Financial-Statements-Analysis-Report",
    stack: [
      "Power Query",
      "Power BI",
      "ZoomCharts",
      "DAX and Measures",
      "Canva",
    ],
  },
  {
    id: "P0021",
    title: "Transportation and Logistics Report",
    url: "https://app.powerbi.com/view?r=eyJrIjoiMGIxMWU0OGYtOGYzNC00N2ViLWExZTMtZGE4NTcwZGE5YWFiIiwidCI6IjQ2NTRiNmYxLTBlNDctNDU3OS1hOGExLTAyZmU5ZDk0M2M3YiIsImMiOjl9",
    pic: shipment,
    description:
      "A comprehensive Transportation and Logistics Report. This report is designed to provide valuable insights into transportation and logistics operations, helping businesses optimize their supply chain and improve operational efficiency. Through the use of advanced analytics and data visualization techniques, this report offers a deep dive into key performance indicators, delivery times, and cost analysis. Whether you're a logistics professional looking to enhance your operations or a business owner focused on improving supply chain management, this report is a must-read. Check it out and let me know your thoughts!",
    code: "https://github.com/idowuemmao/Transportation_Logistics_Report",
    stack: [
      "Power Query",
      "Power BI",
      "ZoomCharts",
      "DAX and Measures",
      "Canva",
    ],
  },
  {
    id: "P00",
    title: "Urban Population Report",
    url: "https://app.powerbi.com/view?r=eyJrIjoiNzYzOWJmNzktYTM0Mi00NTk1LWFhOWEtMTlmMmQwMTcxMGJmIiwidCI6IjQ2NTRiNmYxLTBlNDctNDU3OS1hOGExLTAyZmU5ZDk0M2M3YiIsImMiOjl9",
    pic: population,
    description:
      "A comprehensive Urban Population Report. This report is designed to provide valuable insights into urban population trends, helping researchers and policymakers understand demographic changes and their implications. Through the use of advanced analytics and data visualization techniques, this report offers a deep dive into key metrics, migration patterns, and socioeconomic factors. Whether you're a researcher focused on urban studies or a policymaker looking to address community needs, this report is a must-read. Check it out and let me know your thoughts!",
    code: "https://github.com/idowuemmao/Population_and_Urbanization_Trend",
    stack: [
      "Power Query",
      "Power BI",
      "ZoomCharts",
      "DAX and Measures",
      "Canva",
    ],
  },
  {
    id: "P0",
    title: "Airline Delay Report",
    url: "https://app.powerbi.com/view?r=eyJrIjoiZGZiYzdmOTYtZDcyNC00NzQ1LWFlOGQtODk2MjMxOWFiNTQzIiwidCI6IjQ2NTRiNmYxLTBlNDctNDU3OS1hOGExLTAyZmU5ZDk0M2M3YiIsImMiOjl9",
    pic: Airline,
    description:
      "A comprehensive Airline Delay Report. This report is designed to provide valuable insights into airline delay patterns, helping stakeholders understand the causes and impacts of flight delays. Through the use of advanced analytics and data visualization techniques, this report offers a deep dive into key performance indicators, delay reasons, and operational efficiency. Whether you're an airline professional looking to improve on-time performance or a passenger seeking to understand flight reliability, this report is a must-read. Check it out and let me know your thoughts!",
    code: "https://github.com/idowuemmao/Airline_Delay_Report",
    stack: [
      "Power Query",
      "Power BI",
      "ZoomCharts",
      "DAX and Measures",
      "Canva",
    ],
  },
  {
    id: "P1",
    title: "Merchandise Sale Report",
    url: "https://app.powerbi.com/view?r=eyJrIjoiYjBjMGViZWUtNGNlYS00MGVhLTlkNzUtMGU2NjJkMzk1NmRjIiwidCI6IjQ2NTRiNmYxLTBlNDctNDU3OS1hOGExLTAyZmU5ZDk0M2M3YiIsImMiOjl9",
    pic: Merchandise,
    description:
      "A comprehensive Merchandise Sale Report. This report is designed to provide valuable insights into sales performance, helping businesses understand their product demand and optimize inventory management. Through the use of advanced analytics and data visualization techniques, this report offers a deep dive into key sales metrics, customer behavior, and revenue streams. Whether you're a retail professional looking to improve sales strategies or a business owner focused on enhancing customer satisfaction, this report is a must-read. Check it out and let me know your thoughts!",
    code: "https://github.com/idowuemmao/Merchandise_Sale_Report",
    stack: [
      "Power Query",
      "Power BI",
      "ZoomCharts",
      "DAX and Measures",
      "Canva",
    ],
  },
  {
    id: "P212",
    title: "Baby Name Trend Analysis",
    url: "https://mavenshowcase.com/project/31099",
    pic: baby_name_trend,
    description:
      "A comprehensive Baby Name Trend Analysis. This report is designed to provide valuable insights into popular baby names over time, helping parents and researchers understand naming conventions and cultural shifts. Through the use of advanced analytics and data visualization techniques, this report offers a deep dive into key metrics, regional variations, and historical trends. Whether you're a parent looking for inspiration or a researcher interested in demographic studies, this report is a must-read. Check it out and let me know your thoughts!",
    code: "https://github.com/idowuemmao/baby_name_trend_analysis",
    stack: ["SQL", "Postgresql", "PgAdmin"],
  },
  {
    id: "P232",
    title: "Restaurant Order Analysis",
    url: "https://mavenshowcase.com/project/30934",
    pic: restaurant_order,
    description:
      "A comprehensive Restaurant Order Analysis. This report is designed to provide valuable insights into customer ordering behavior, helping restaurant owners optimize their menu offerings and improve operational efficiency. Through the use of advanced analytics and data visualization techniques, this report offers a deep dive into key metrics, popular dishes, and customer preferences. Whether you're a restaurant owner looking to enhance your business or a food industry professional interested in consumer trends, this report is a must-read. Check it out and let me know your thoughts!",
    code: "https://github.com/idowuemmao/Restaurant_Order_Analysis",
    stack: ["SQL", "Postgresql", "PgAdmin"],
  },
  {
    id: "P2",
    title: "Adventure Works Report",
    url: "https://www.linkedin.com/posts/emmanuel-idowu-analyst_my-adventure-work-activity-7247515756182069248-VbCK",
    pic: adventureworks,
    description:
      "A comprehensive Adventure Works Report. This report is designed to provide valuable insights into the performance of Adventure Works, helping stakeholders understand key business metrics and operational efficiency. Through the use of advanced analytics and data visualization techniques, this report offers a deep dive into sales data, customer behavior, and inventory management. Whether you're a business owner looking to improve performance or a data analyst interested in retail metrics, this report is a must-read. Check it out and let me know your thoughts!",
    code: "https://github.com/idowuemmao/AdventureWorksDashboard",
    stack: [
      "Power Query",
      "Power BI",
      "ZoomCharts",
      "DAX and Measures",
      "Canva",
    ],
  },

  {
    id: "P3",
    title: "KPI Dashboard",
    url: "https://www.linkedin.com/posts/emmanuel-idowu-analyst_dataanalytics-excel-kpidashboard-activity-7219012388312801280-dOij",
    pic: KPI,
    description:
      "A comprehensive KPI Dashboard. This dashboard is designed to provide a clear overview of key performance indicators, helping stakeholders track progress and make data-driven decisions. Through the use of advanced analytics and data visualization techniques, this dashboard offers a deep dive into critical metrics and trends. Whether you're a business leader looking to monitor performance or a data analyst interested in visualizing complex data, this dashboard is a must-see. Check it out and let me know your thoughts!",
    code: "https://github.com/idowuemmao/KPI-Dashboard",
    stack: ["Advanced Excel", "Google Sheet", "VBA", "Canva"],
  },
  {
    id: "P4",
    title: "Regional Sales Dashboard",
    url: "https://www.linkedin.com/posts/emmanuel-idowu-analyst_dataanalytics-excel-datavisualization-activity-7221061450386010112-YBsB",
    pic: regional,
    description:
      "A comprehensive Regional Sales Dashboard. This dashboard is designed to provide insights into sales performance across different regions, helping businesses understand local market dynamics and optimize their sales strategies. Through the use of advanced analytics and data visualization techniques, this dashboard offers a deep dive into regional sales data, customer behavior, and revenue streams. Whether you're a sales manager looking to improve regional performance or a business owner focused on expanding market reach, this dashboard is a must-see. Check it out and let me know your thoughts!",
    code: "https://github.com/idowuemmao/Regional-Sales-Dashboard",
    stack: ["Advanced Excel", "Google Sheet", "VBA", "Canva"],
  },
  {
    id: "P5",
    title: "Candy Research Report",
    url: "https://app.powerbi.com/view?r=eyJrIjoiZDY3MTQxNWYtMjIyYS00MzY5LWFjNzItZGQwNGNhNjNiOTVmIiwidCI6IjQ2NTRiNmYxLTBlNDctNDU3OS1hOGExLTAyZmU5ZDk0M2M3YiIsImMiOjl9",
    pic: candy,
    description:
      "A comprehensive Candy Research Report. This report is designed to provide valuable insights into candy sales trends, customer preferences, and market dynamics. Through the use of advanced analytics and data visualization techniques, this report offers a deep dive into key metrics and consumer behavior. Whether you're a candy manufacturer looking to optimize your product lineup or a market researcher interested in confectionery trends, this report is a must-read. Check it out and let me know your thoughts!",
    code: "https://github.com/idowuemmao/Candy_Research_Report",
    stack: ["Power Query", "Power BI", "DAX and Measures", "Canva"],
  },
  {
    id: "P6",
    title: "Employees Performance Report",
    url: "https://www.linkedin.com/posts/emmanuel-idowu-analyst_datadna-dashboard-visualizations-activity-7255597262561509376-tzJe",
    pic: employee,
    description:
      "A comprehensive Employees Performance Report. This report is designed to provide valuable insights into employee performance metrics, helping businesses understand workforce productivity and identify areas for improvement. Through the use of advanced analytics and data visualization techniques, this report offers a deep dive into key performance indicators, employee engagement, and overall performance trends. Whether you're an HR professional looking to enhance employee performance or a business owner focused on optimizing workforce management, this report is a must-read. Check it out and let me know your thoughts!",
    code: "https://github.com/idowuemmao/Employee_Performance",
    stack: ["Power Query", "Power BI", "DAX and Measures", "Canva"],
  },
  {
    id: "PR6",
    title: "ODI Cricket Match Report",
    url: "https://www.linkedin.com/posts/emmanuel-idowu-analyst_powerbi-cricketanalytics-datavisualization-activity-7348259587562569728-N8Mx",
    pic: cricket,
    description:
      "A comprehensive ODI Cricket Match Report. This report is designed to provide valuable insights into cricket match performance, helping fans and analysts understand key metrics and trends in the game. Through the use of advanced analytics and data visualization techniques, this report offers a deep dive into player performance, team dynamics, and match outcomes. Whether you're a cricket enthusiast looking to analyze match data or a sports analyst focused on cricket statistics, this report is a must-read. Check it out and let me know your thoughts!",
    code: "https://github.com/idowuemmao/Cricket_Report",
    stack: ["Web Scraping", "Power Query", "Power BI", "DAX and Measures"],
  },
  {
    id: "P7",
    title: "Halloween Candy Report",
    url: "https://mavenshowcase.com/project/20500",
    pic: halloween,
    description:
      "A comprehensive Halloween Candy Report. This report is designed to provide valuable insights into Halloween candy sales trends, customer preferences, and market dynamics. Through the use of advanced analytics and data visualization techniques, this report offers a deep dive into key metrics and consumer behavior during the Halloween season. Whether you're a candy manufacturer looking to optimize your product lineup or a market researcher interested in seasonal confectionery trends, this report is a must-read. Check it out and let me know your thoughts!",
    code: "https://github.com/idowuemmao/Mavin-Halloween-Candy-Dashboard",
    stack: ["Power Query", "Power BI", "DAX and Measures", "Canva"],
  },
  {
    id: "P8",
    title: "Christmas Holiday Sales Report",
    url: "https://app.powerbi.com/view?r=eyJrIjoiMTcyMzUyZTktNWZlYy00OWVmLWFiYjMtMWJlMDU2OTA0NTk2IiwidCI6IjQ2NTRiNmYxLTBlNDctNDU3OS1hOGExLTAyZmU5ZDk0M2M3YiIsImMiOjl9",
    pic: christmas,
    description:
      "A comprehensive Christmas Holiday Sales Report. This report is designed to provide valuable insights into holiday sales performance, helping businesses understand seasonal trends and customer behavior. Through the use of advanced analytics and data visualization techniques, this report offers a deep dive into key metrics and sales dynamics during the Christmas season. Whether you're a retail manager looking to optimize inventory or a business owner focused on holiday marketing strategies, this report is a must-read. Check it out and let me know your thoughts!",
    code: "https://github.com/idowuemmao/Mavin-Halloween-Candy-Dashboard",
    stack: [
      "Power Query",
      "Power BI",
      "ZoomCharts",
      "DAX and Measures",
      "Canva",
    ],
  },
  {
    id: "P9",
    title: "Spotify Streaming Report",
    url: "https://mavenshowcase.com/project/26185",
    pic: spotify,
    description:
      "A comprehensive Spotify Streaming Report. This report is designed to provide valuable insights into music streaming behavior, helping artists and record labels understand listener preferences and engagement patterns. Through the use of advanced analytics and data visualization techniques, this report offers a deep dive into key metrics and user behavior on the Spotify platform. Whether you're a musician looking to optimize your music discovery or a data analyst focused on streaming trends, this report is a must-read. Check it out and let me know your thoughts!",
    code: "https://github.com/idowuemmao/Spotify-Streaming-Report",
    stack: ["Power Query", "Power BI", "DAX and Measures", "Canva"],
  },
  {
    id: "P10",
    title: "Email Campaign Report",
    url: "https://app.powerbi.com/view?r=eyJrIjoiZGNiNjc5MWUtNjkxZi00ZTBlLTg5Y2QtMDU5NzI3NTlmMjc1IiwidCI6IjQ2NTRiNmYxLTBlNDctNDU3OS1hOGExLTAyZmU5ZDk0M2M3YiIsImMiOjl9",
    pic: email,
    description:
      "A comprehensive Email Campaign Report. This report is designed to provide valuable insights into email marketing performance, helping businesses understand open rates, click-through rates, and overall campaign effectiveness. Through the use of advanced analytics and data visualization techniques, this report offers a deep dive into key metrics and user engagement patterns across different email campaigns. Whether you're a marketing professional looking to optimize your email strategies or a business owner focused on improving customer communication, this report is a must-read. Check it out and let me know your thoughts!",
    code: "https://github.com/idowuemmao/Email_Campaign_Report",
    stack: ["Power Query", "Power BI", "DAX and Measures", "Canva"],
  },
  {
    id: "P11",
    title: "Indian Box Office Report",
    url: "https://www.linkedin.com/feed/update/urn:li:activity:7287108125193646080",
    pic: india,
    description:
      "A comprehensive Indian Box Office Report. This report is designed to provide valuable insights into the Indian film industry, helping stakeholders understand box office performance, audience preferences, and market dynamics. Through the use of advanced analytics and data visualization techniques, this report offers a deep dive into key metrics and trends within the Indian cinema landscape. Whether you're a film enthusiast looking to explore regional box office data or a business professional interested in the Indian entertainment market, this report is a must-read. Check it out and let me know your thoughts!",
    code: "https://github.com/idowuemmao/India-Box-Office-Report",
    stack: ["Power Query", "Power BI", "DAX and Measures", "Canva"],
  },
  {
    id: "P12",
    title: "Supply Chain Report",
    url: "https://app.powerbi.com/view?r=eyJrIjoiNDI2NTIxNjYtNTdmMi00NWRjLWE4NmQtMjE3YTU4NTliNjU4IiwidCI6IjQ2NTRiNmYxLTBlNDctNDU3OS1hOGExLTAyZmU5ZDk0M2M3YiIsImMiOjl9",
    pic: supply,
    description:
      "A comprehensive Supply Chain Report. This report is designed to provide valuable insights into supply chain operations, helping businesses understand inventory management, logistics performance, and overall supply chain efficiency. Through the use of advanced analytics and data visualization techniques, this report offers a deep dive into key metrics and operational dynamics across different supply chain segments. Whether you're a supply chain manager looking to optimize your processes or a business owner focused on improving operational effectiveness, this report is a must-read. Check it out and let me know your thoughts!",
    code: "https://github.com/idowuemmao/Supply_chain_Report",
    stack: [
      "Power Query",
      "Power BI",
      "ZoomCharts",
      "DAX and Measures",
      "Canva",
    ],
  },
  {
    id: "P13",
    title: "HealthCare Report",
    url: "https://docs.google.com/spreadsheets/d/1IAv51ATZFR9F0tO4JaN-zjdS8oVl98mmnCR7RBgSKTA/edit",
    pic: hub,
    description:
      "A comprehensive HealthCare Report. This report is designed to provide valuable insights into healthcare operations, helping businesses understand patient outcomes, resource allocation, and overall performance. Through the use of advanced analytics and data visualization techniques, this report offers a deep dive into key metrics and operational dynamics across different healthcare segments. Whether you're a healthcare administrator looking to optimize your processes or a business owner focused on improving patient care, this report is a must-read. Check it out and let me know your thoughts!",
    code: "https://github.com/idowuemmao/Peace_HealthCare_Report",
    stack: ["Google Sheet"],
  },
  {
    id: "P14",
    title: "HealthCare Data Cleaning",
    url: "https://www.linkedin.com/posts/emmanuel-idowu-analyst_datacleaningchallenge-greendatasolutions-activity-7292845953332514817-FdvO",
    pic: HealthCare,
    description:
      "A comprehensive HealthCare Data Cleaning project. This project focuses on ensuring the quality and consistency of healthcare data, which is crucial for accurate analysis and informed decision-making. Through the use of advanced data cleaning techniques and automation tools, this project offers a systematic approach to identifying and resolving data issues within healthcare datasets. Whether you're a data analyst working with healthcare information or a healthcare professional focused on data integrity, this project is a must-see. Check it out and let me know your thoughts!",
    code: "https://github.com/idowuemmao/HealthCare_Data_Cleaning",
    stack: ["Power Query", "Ms Excel"],
  },
];
export default ProjectData;
